var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    a-star-rating\n    tw-inline-flex tw-relative tw-whitespace-nowrap tw-leading-none\n  "},[_c('div',{staticClass:"tw-absolute tw-overflow-hidden tw-z-10 tw-inset-0",style:({ width: _vm.valueInPercent + '%' })},_vm._l((_vm.maxStars),function(index){return _c('a-icon',{key:'star-' + index,staticClass:"tw-text-yellow-star",class:{
        'tw-w-3 tw-h-3': _vm.small,
        'tw-w-6 tw-h-6': !_vm.large && !_vm.small,
        'tw-w-8 tw-h-8': _vm.large,
      },attrs:{"value":_vm.mdiStar,"title":"Gelber Stern"}})}),1),_vm._l((_vm.maxStars),function(index){return _c('a-icon',{key:'star-' + index,staticClass:"tw-text-gray-200",class:{
      'tw-w-3 tw-h-3': _vm.small,
      'tw-w-6 tw-h-6': !_vm.large && !_vm.small,
      'tw-w-8 tw-h-8': _vm.large,
    },attrs:{"value":_vm.mdiStar,"title":"Grauer Stern"}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }